import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, map } from 'rxjs';
import { WorkOrderDto } from 'src/api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorder-badge',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './workorder-badge.component.html',
  styleUrls: ['./workorder-badge.component.scss'],
})
export class WorkorderBadgeComponent implements OnInit {
  @Input({ required: true }) workOrder$!: Observable<WorkOrderDto | undefined>;

  isBillable$!: Observable<boolean | undefined>;
  isNonBillable$!: Observable<boolean | undefined>;
  isMandatory$!: Observable<boolean | undefined>;

  constructor() {}

  ngOnInit(): void {
    this.isBillable$ = this.workOrder$.pipe(
      map((workOrder) => {
        return workOrder?.isBillable && !workOrder?.clientValidation;
      })
    );

    this.isNonBillable$ = this.workOrder$.pipe(
      map((workOrder) => {
        return !workOrder?.isBillable;
      })
    );

    this.isMandatory$ = this.workOrder$.pipe(
      map((workOrder) => {
        return workOrder?.clientValidation;
      })
    );
  }
}
